var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 44,
    viewBox: "0 0 85 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2455 9.20267C20.2455 9.61781 20.411 9.95312 20.7421 10.2246C21.0731 10.496 21.496 10.6237 21.9926 10.6078C22.4891 10.6078 22.912 10.4641 23.2431 10.1767C23.5741 9.88926 23.7396 9.53798 23.7396 9.12283C23.7396 8.73962 23.5741 8.40431 23.2431 8.14883C22.912 7.89336 22.4891 7.76562 21.9926 7.76562C21.496 7.76562 21.0731 7.90933 20.7421 8.18077C20.411 8.45221 20.2455 8.80349 20.2455 9.20267Z",
    fill: "url(#paint0_linear_424_431649)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3534 12.3003H20.6133V22.4554H23.3534V12.3003Z",
    fill: "url(#paint1_linear_424_431649)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0413 14.6475C14.5264 13.8651 13.8275 13.2583 12.9264 12.8272C12.0437 12.3961 11.0139 12.1885 9.89214 12.1885C9.11977 12.1885 8.43935 12.3003 7.79571 12.5238C7.15207 12.7474 6.60037 13.0827 6.14063 13.5298V8.34044H3.40056V22.4235H5.99351V21.1142C6.45325 21.5932 7.00495 21.9604 7.66698 22.1999C8.32901 22.4394 9.0646 22.5672 9.87375 22.5672C11.0139 22.5672 12.0253 22.3596 12.9264 21.9285C13.8275 21.4974 14.5264 20.8906 15.0413 20.0923C15.5562 19.2939 15.8136 18.3838 15.8136 17.3619C15.8136 16.34 15.5562 15.4299 15.0413 14.6475ZM13.0368 17.3778C13.0368 18.3199 12.7058 19.1023 12.0621 19.6771C11.4001 20.2519 10.5726 20.5553 9.57951 20.5553C8.93587 20.5553 8.3474 20.4276 7.8141 20.1721C7.28079 19.9007 6.87622 19.5334 6.5636 19.0544C6.25097 18.5754 6.10385 18.0165 6.10385 17.3778C6.10385 16.7392 6.25097 16.1803 6.5636 15.7013C6.87622 15.2063 7.28079 14.8391 7.8141 14.5836C8.32901 14.3281 8.91748 14.2004 9.57951 14.2004C10.5909 14.2004 11.4185 14.5038 12.0621 15.0786C12.7058 15.6534 13.0368 16.4198 13.0368 17.3778Z",
    fill: "url(#paint2_linear_424_431649)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1279 8.34044H31.8679V22.4394H29.1279V8.34044Z",
    fill: "url(#paint3_linear_424_431649)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3824 8.34044H37.6423V22.4394H40.3824V8.34044Z",
    fill: "url(#paint4_linear_424_431649)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2855 10.2246C45.9545 9.95312 45.7889 9.61781 45.7889 9.20267C45.7889 8.80349 45.9545 8.45221 46.2855 8.18077C46.6165 7.90933 47.0395 7.76562 47.536 7.76562C48.0325 7.76562 48.4555 7.89336 48.7865 8.14883C49.1175 8.40431 49.283 8.73962 49.283 9.12283C49.283 9.53798 49.1175 9.88926 48.7865 10.1767C48.4555 10.4641 48.0325 10.6078 47.536 10.6078C47.0395 10.6237 46.6165 10.496 46.2855 10.2246Z",
    fill: "url(#paint5_linear_424_431649)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1567 12.3003H48.8968V22.4554H46.1567V12.3003Z",
    fill: "url(#paint6_linear_424_431649)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5056 20.0603C55.0389 20.8587 55.7745 21.4654 56.7308 21.9125C57.6687 22.3596 58.7353 22.5831 59.9306 22.5831C61.1259 22.5831 62.1925 22.3596 63.1488 21.9125C64.1051 21.4654 64.8407 20.8587 65.374 20.0603C65.9073 19.2779 66.1647 18.3838 66.1647 17.3778C66.1647 16.3719 65.9073 15.4778 65.374 14.6954C64.8407 13.913 64.1051 13.3062 63.1488 12.8591C62.1925 12.4121 61.1259 12.1885 59.9306 12.1885C58.7536 12.1885 57.687 12.4121 56.7308 12.8591C55.7745 13.2903 55.0389 13.913 54.5056 14.6954C53.9723 15.4778 53.7149 16.3719 53.7149 17.3778C53.7149 18.3678 53.9723 19.262 54.5056 20.0603ZM63.4063 17.3778C63.4063 18.3199 63.0752 19.1023 62.4132 19.6771C61.7696 20.2519 60.9236 20.5553 59.9122 20.5553C58.9008 20.5553 58.0732 20.2679 57.4296 19.6771C56.7859 19.1023 56.4549 18.3359 56.4549 17.3778C56.4549 16.4358 56.7859 15.6694 57.4296 15.0786C58.0732 14.4878 58.9008 14.2004 59.9122 14.2004C60.9236 14.2004 61.7512 14.5038 62.4132 15.0786C63.0752 15.6534 63.4063 16.4198 63.4063 17.3778Z",
    fill: "url(#paint7_linear_424_431649)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1524 13.3062C82.0351 14.0567 82.4948 15.1584 82.4948 16.6274V22.4394H79.7548V16.9308C79.7548 16.0366 79.5157 15.382 79.0376 14.9189C78.5594 14.4718 77.879 14.2483 76.9779 14.2483C75.9665 14.2483 75.1757 14.5038 74.5872 15.0307C73.9988 15.5576 73.7045 16.308 73.7045 17.298V22.4235H70.9645V12.2684H73.5758V13.5777C74.0356 13.1146 74.6056 12.7474 75.286 12.5079C75.9665 12.2684 76.7388 12.1406 77.6032 12.1406C79.0927 12.1885 80.2697 12.5558 81.1524 13.3062Z",
    fill: "url(#paint8_linear_424_431649)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6475 32.8092C23.6475 31.2764 23.2061 30.1427 22.3418 29.3763C21.4775 28.6259 20.319 28.2427 18.8478 28.2267C18.0018 28.2267 17.2295 28.3704 16.5123 28.6418C15.8135 28.9133 15.2066 29.3124 14.7469 29.8394C14.3423 29.2965 13.809 28.8973 13.1469 28.6259C12.5033 28.3544 11.7493 28.2267 10.9218 28.2267C10.2046 28.2267 9.54256 28.3385 8.9357 28.546C8.32884 28.7536 7.81392 29.0729 7.37257 29.4881V28.4023H3.40039V38.7011H7.55647V33.5916C7.55647 32.8252 7.74037 32.2504 8.12655 31.8672C8.49435 31.484 9.00926 31.2924 9.6529 31.2924C10.8482 31.2924 11.4551 31.9949 11.4551 33.4V38.7011H15.6112V33.5916C15.6112 32.8252 15.7951 32.2504 16.1813 31.8672C16.5491 31.484 17.064 31.2924 17.6892 31.2924C18.2593 31.2924 18.7006 31.468 19.0133 31.8033C19.3259 32.1386 19.4914 32.6815 19.4914 33.4V38.7011H23.6475V32.8092Z",
    fill: "url(#paint9_linear_424_431649)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4656 32.5314H32.6217V38.7171H28.4656V32.5314Z",
    fill: "url(#paint10_linear_424_431649)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1287 32.8092C50.1287 31.2764 49.6874 30.1427 48.7863 29.3763C47.9036 28.6259 46.7082 28.2427 45.2187 28.2267C44.4647 28.2267 43.7659 28.3384 43.1222 28.562C42.497 28.7855 41.9269 29.1049 41.4672 29.52V28.4023H37.5134V38.7011H41.6695V33.7194C41.6695 32.921 41.8901 32.2983 42.3131 31.8991C42.736 31.4999 43.3061 31.2924 44.0233 31.2924C45.329 31.2924 45.9727 31.9949 45.9727 33.4V38.7011H50.1287V32.8092Z",
    fill: "url(#paint11_linear_424_431649)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7277 24.6021V38.7011H63.7739V37.6792C63.0015 38.4776 61.843 38.8768 60.2982 38.8768C59.2132 38.8768 58.2386 38.6532 57.3375 38.2221C56.4364 37.791 55.7376 37.1683 55.2227 36.3539C54.7077 35.5396 54.4503 34.5976 54.4503 33.5437C54.4503 32.4739 54.7077 31.5478 55.2227 30.7335C55.7376 29.9352 56.4364 29.3124 57.3375 28.8813C58.2202 28.4502 59.2132 28.2426 60.2982 28.2426C61.7142 28.2426 62.7992 28.5939 63.59 29.3124V24.6021H67.7277ZM62.928 35.364C63.3877 34.9329 63.6268 34.3261 63.6268 33.5437C63.6268 32.7773 63.4061 32.1865 62.9464 31.7554C62.4866 31.3243 61.8981 31.1167 61.1625 31.1167C60.4269 31.1167 59.8385 31.3403 59.3604 31.7554C58.9006 32.1865 58.6615 32.7773 58.6615 33.5437C58.6615 34.3102 58.9006 34.9169 59.3604 35.364C59.8201 35.7951 60.4269 36.0186 61.1625 36.0186C61.8614 36.0186 62.4498 35.7951 62.928 35.364Z",
    fill: "url(#paint12_linear_424_431649)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6447 37.8229C72.2332 38.1423 73.0056 38.3977 73.9618 38.5893C74.9181 38.781 75.8927 38.8768 76.8674 38.8768C78.0995 38.8768 79.1661 38.7331 80.0488 38.4456C80.9315 38.1423 81.5936 37.7431 82.0533 37.2321C82.513 36.7212 82.7337 36.1304 82.7337 35.4917C82.7337 34.7093 82.4947 34.0866 82.0165 33.6555C81.5384 33.2084 80.9867 32.905 80.3431 32.7454C79.6994 32.5857 78.8903 32.442 77.9156 32.3143C77.1432 32.2185 76.5916 32.1227 76.2605 32.0269C75.9295 31.9311 75.764 31.7554 75.764 31.5159C75.764 31.2924 75.9111 31.1167 76.2238 30.989C76.5364 30.8613 77.0145 30.7974 77.6766 30.7974C78.9087 30.7974 80.0488 31.0529 81.0971 31.5638L82.3476 29.1049C81.7959 28.8334 81.0787 28.6259 80.2327 28.4662C79.3868 28.3225 78.5409 28.2426 77.6766 28.2426C76.4628 28.2426 75.4146 28.3864 74.5503 28.6897C73.686 28.9771 73.0239 29.3923 72.5642 29.9032C72.1045 30.4142 71.8838 31.005 71.8838 31.6596C71.8838 32.458 72.1229 33.0807 72.601 33.5278C73.0791 33.9748 73.6492 34.2782 74.3112 34.4379C74.9916 34.5976 75.7824 34.7413 76.7387 34.8371C77.4927 34.9169 78.026 35.0127 78.3754 35.1085C78.7248 35.2043 78.8903 35.348 78.8903 35.5875C78.8903 35.827 78.7432 35.9867 78.4673 36.1144C78.1915 36.2262 77.7133 36.2901 77.0329 36.2901C76.3157 36.2901 75.5617 36.2102 74.8261 36.0346C74.0722 35.8749 73.4285 35.6354 72.8952 35.348L71.6447 37.8229Z",
    fill: "url(#paint13_linear_424_431649)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5131 30.18C31.5367 30.18 32.3665 29.46 32.3665 28.5717C32.3665 27.6835 31.5367 26.9634 30.5131 26.9634C29.4894 26.9634 28.6596 27.6835 28.6596 28.5717C28.6596 29.46 29.4894 30.18 30.5131 30.18ZM30.5131 31.6096C32.4466 31.6096 34.014 30.2495 34.014 28.5717C34.014 26.8939 32.4466 25.5338 30.5131 25.5338C28.5796 25.5338 27.0122 26.8939 27.0122 28.5717C27.0122 30.2495 28.5796 31.6096 30.5131 31.6096Z",
    fill: "url(#paint14_linear_424_431649)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_424_431649",
    x1: -7.61813,
    y1: 13.4245,
    x2: 107.525,
    y2: 13.4245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24EE12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_424_431649",
    x1: -7.61813,
    y1: 13.4245,
    x2: 107.525,
    y2: 13.4245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24EE12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_424_431649",
    x1: -7.61813,
    y1: 13.4245,
    x2: 107.525,
    y2: 13.4245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24EE12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_424_431649",
    x1: -7.61813,
    y1: 13.4245,
    x2: 107.525,
    y2: 13.4245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24EE12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_424_431649",
    x1: -7.61813,
    y1: 13.4245,
    x2: 107.525,
    y2: 13.4245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24EE12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_424_431649",
    x1: -7.61813,
    y1: 13.4245,
    x2: 107.525,
    y2: 13.4245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24EE12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_424_431649",
    x1: -7.61813,
    y1: 13.4245,
    x2: 107.525,
    y2: 13.4245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24EE12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_424_431649",
    x1: -7.61813,
    y1: 13.4245,
    x2: 107.525,
    y2: 13.4245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24EE12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_424_431649",
    x1: -7.61813,
    y1: 13.4245,
    x2: 107.525,
    y2: 13.4245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24EE12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_424_431649",
    x1: -7.61813,
    y1: 13.4245,
    x2: 107.525,
    y2: 13.4245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24EE12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_424_431649",
    x1: -7.61813,
    y1: 13.4245,
    x2: 107.525,
    y2: 13.4245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24EE12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_424_431649",
    x1: -7.61813,
    y1: 13.4245,
    x2: 107.525,
    y2: 13.4245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24EE12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_424_431649",
    x1: -7.61813,
    y1: 13.4245,
    x2: 107.525,
    y2: 13.4245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24EE12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_424_431649",
    x1: -7.61813,
    y1: 13.4245,
    x2: 107.525,
    y2: 13.4245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24EE12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_424_431649",
    x1: -7.61813,
    y1: 13.4245,
    x2: 107.525,
    y2: 13.4245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24EE12"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cc351c0d.svg";
export { ForwardRef as ReactComponent };